import React, { useState, useCallback, useRef, useEffect, forwardRef } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const SamplereactCroper = forwardRef(({ cropSize, key, isVertical, style, file, src, getCropeByindex, index }) => {
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const previewCanvasRef = useRef(null);
  const [processedSrc, setProcessedSrc] = useState(null);
  const [loading, setLoading] = useState(false);

  const cropped = (cropSize) => {
    if (isVertical === false) {
      return cropSize === '4/3' ? 7 / 4 : 1;
    }
    return cropSize === '4/3' ? 4 / 7 : 1;
  };
  const [crop, setCrop] = useState({
    unit: '%',
    width: 30,
    x: 30,
    y: 20,
    height: cropSize === 'FREE' && 30,
    aspect: cropSize === 'FREE' ? 0 : cropped(cropSize),
  });

  // Function to convert blob to base64 (from ImgDropzone.js reference)
  async function getS3ImageAsBase64(s3ImageUrl) {
    try {
      const response = await fetch(s3ImageUrl, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();
      return await convertBlobToBase64(blob);
    } catch (error) {
      throw new Error(`Error fetching image from S3: ${error.message}`);
    }
  }

  function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  // Process S3 URLs on component mount (similar to ImgDropzone.js approach)
  useEffect(() => {
    const handleImageLoad = async (imageUrl) => {
      try {
        setLoading(true);
        const base64String = await getS3ImageAsBase64(imageUrl);
        setProcessedSrc(base64String);
      } catch (error) {
        console.error('Failed to load image from S3:', error);
        // Fallback to original src if conversion fails
        setProcessedSrc(src);
      } finally {
        setLoading(false);
      }
    };

    if (typeof src === 'string' && src?.includes('s3.eu-west-2.amazonaws.com')) {
      handleImageLoad(src);
    } else {
      // For blob URLs or other sources, use directly
      setProcessedSrc(src);
    }
  }, [src]);

  console.log('completedCropcompletedCrop', completedCrop);
  console.log('cropSizecropSizecropSize', cropSize);
  console.log('keykeykey', key);
  console.log('previewCanvasRefpreviewCanvasRef', previewCanvasRef.current);
  console.log('imgRefimgRefimgRefimgRef', imgRef.current);
  console.log('processedSrcprocessedSrc', processedSrc);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
  }, [completedCrop]);

  const uploadCroppedImg = (canvas, crops) => {
    if (!crops || !canvas) {
      return;
    }
    const canvasRef = previewCanvasRef.current;
    return canvasRef.toDataURL('image/png');
  };

  useEffect(() => {
    const imageRes = uploadCroppedImg(previewCanvasRef?.current, completedCrop);
    if (imageRes) {
      const obj = { index: index || 0, imageRes };
      getCropeByindex(obj);
    }
  }, [completedCrop]);

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const preview = (key) => {
    return (
      <canvas
        key={key}
        ref={previewCanvasRef}
        style={{
          width: Math.round(completedCrop?.width ?? 0),
          height: Math.round(completedCrop?.height ?? 0),
        }}
      />
    );
  };
  console.log('srcsrc', src);

  // Show loading state while processing S3 URL
  if (loading || !processedSrc) {
    return (
      <div style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>Loading image...</div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'none' }}>{preview(key)}</div>
      <ReactCrop
        key={key}
        style={style}
        src={processedSrc}
        onImageLoaded={onLoad}
        crop={crop}
        onChange={(c) => setCrop(c)}
        onComplete={(c) => setCompletedCrop(c)}
      />
    </div>
  );
});

export default SamplereactCroper;
